export enum ErknmAnalyticsProsecutorOrganizationActionsEnum {
  INIT_PAGE = 'INIT_PAGE',
  GET_DATA = 'GET_DATA',
  GET_DATA_NEXT = 'GET_DATA_NEXT',
  SET_DATA = 'SET_DATA',
  SET_FILTER = 'SET_FILTER',
  SET_TABLE_COLUMNS = 'SET_TABLE_COLUMNS',
  GET_ADDITIONAL_COLUMNS = 'GET_ADDITIONAL_COLUMNS',
  EXPORT = 'EXPORT',
  EXPORT_KNM_LIST = 'EXPORT_KNM_LIST',
  GET_KNM_LIST = 'GET_KNM_LIST',
  GET_KNM_LIST_NEXT_PAGE = 'GET_KNM_LIST_NEXT_PAGE',
  SET_KNM_LIST = 'SET_KNM_LIST',
  SET_ORDER = 'SET_ORDER',
}
